import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/crateBooking'

const crateBooking = axios.create({
  baseURL
})

interceptorsSetup(crateBooking)

export default class CrateBookings {
  static async getTable (bookingQuery) {
    const result = await crateBooking.get('/' + bookingQuery.siteId, {
      params:
      {
        start: bookingQuery.start,
        end: bookingQuery.end
      }
    })
    return result.data
  }

  static async createBooking (booking) {
    const result = await crateBooking.post('/', booking)
    return result.data
  }

  static async updateBooking (booking) {
    const result = await crateBooking.post('/update', booking)
    return result.data
  }

  static async archiveBooking (booking) {
    const result = await crateBooking.put('/archive/' + booking)
    return result.data
  }

  // SAP shipments for the week, each already placed at its manual date/time when
  // one was set, plus the site's daily slot limit.
  static async getSchedule (scheduleQuery) {
    const result = await crateBooking.get('/schedule/' + scheduleQuery.siteId, {
      params: {
        start: scheduleQuery.start,
        end: scheduleQuery.end
      }
    })
    return result.data
  }

  // Bookings matching an RO or OB anywhere in the search window, each with the
  // date it is displayed at.
  static async searchSchedule (searchQuery) {
    const result = await crateBooking.get('/schedule/search/' + searchQuery.siteId, {
      params: {
        q: searchQuery.term
      }
    })
    return result.data
  }

  static async saveSchedule (schedule) {
    const result = await crateBooking.post('/schedule', schedule)
    return result.data
  }

  // Sends the booking back to its SAP date.
  static async clearSchedule (schedule) {
    const result = await crateBooking.put('/schedule/archive', schedule)
    return result.data
  }
}
